import { useNavigate } from 'react-router-dom';
import TextWithReferences from '../components/organisms/PageElements/TextWithReferences/TextWithReferences';
import TopBar from '../components/molecules/TopBar';
import TopBarBackButton from '../components/atoms/TopBarBackButton';
import { APP_NAME } from 'src/constants';
import { useAppSelector } from 'src/store/hooks';

const Contact = () => {
    const navigate = useNavigate();
    const config = useAppSelector(state => state.globalState.config);

    const studyName = config?.name || APP_NAME;

    return (
        <div className="content">
            <TopBar
                title="Kontakt / Fragen"
                icon={'icon_contact.svg'}
                leftButtons={[<TopBarBackButton onClick={() => navigate('../settings')} />]}
            />
            <div className="content-container">
                <p className="read">Bei Fragen zur Studie oder Problemen mit der {studyName} App kannst Du Dich hier melden. </p>

                <h4 className="contact-caption">E-Mail:</h4>
                <a href={`mailto:${config?.contact.email}`}>{config?.contact.email}</a>
                <h4 className="contact-caption">Internet:</h4> 
                <TextWithReferences text={`{{ link https://${config?.contact.website} ${config?.contact.website} }}`}/>
                <h4 className="contact-caption">Anschrift:</h4> 
                {config?.contact.address.organizationName}<br />
                {config?.contact.address.departmentName} <br />
                {config?.contact.address.personName}<br />
                {config?.contact.address.streetName}<br />
                {config?.contact.address.postalCode} {config?.contact.address.cityName}
            </div>
        </div>
    );
};

export default Contact;